import React from "react";
import { Mail, Phone, MapPin } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-bold mb-4">
              KJP PROPERTIES <span className="text-blue-400">LLC</span>
            </h3>
            <p className="text-gray-400 leading-relaxed">
              A single source solution for all your commercial real estate needs. Trust, integrity, and
              excellence in every transaction.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => document.getElementById('home')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-blue-400 transition-colors"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-blue-400 transition-colors"
                >
                  About Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('properties')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-blue-400 transition-colors"
                >
                  Properties
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-blue-400 transition-colors"
                >
                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-blue-400 transition-colors"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Information</h4>
            <ul className="space-y-3">
              <li className="flex items-center text-gray-400">
                <Mail size={18} className="mr-2 text-blue-400" />
                <a href="mailto:info@kjppropertygroup.com" className="hover:text-blue-400 transition-colors">
                  info@kjppropertygroup.com
                </a>
              </li>
              <li className="flex items-center text-gray-400">
                <Phone size={18} className="mr-2 text-blue-400" />
                <a href="tel:+18324646257" className="hover:text-blue-400 transition-colors">
                  (832) 464-6257
                </a>
              </li>
              <li className="flex items-start text-gray-400">
                <MapPin size={18} className="mr-2 text-blue-400 mt-1" />
                <span>
                  1014 GATECREST DR<br />
                  HOUSTON, TX 77032
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-10 pt-8 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} KJP Properties LLC. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;